import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import { DIALOG_WIDTH } from './constants/dimensions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const styles = {
  container: {
    outline: 0
  },
  paper: {
    outline: 0,
    minWidth: DIALOG_WIDTH
  },
  content: {
    '&:first-child': {
      padding: 0
    }
  },
  action: {},
  withAdditionalAction: {
    // set justifyContent to default value to fix IE11 layout bug
    // see https://github.com/mui-org/material-ui-pickers/pull/267
    justifyContent: 'flex-start',
    '& > *:first-child': {
      marginRight: 'auto'
    }
  }
};

const PickersModalDialog = props => {
  const {
    cancelText = 'Cancel',
    children,
    classes,
    clearable = false,
    clearText = 'Clear',
    DialogProps = {},
    okText = 'OK',
    onAccept,
    onClear,
    onDismiss,
    onSetToday,
    open,
    showTodayButton = false,
    todayText = 'Today'
  } = props;
  return /*#__PURE__*/_jsxs(Dialog, _extends({
    open: open,
    onClose: onDismiss
  }, DialogProps, {
    classes: _extends({}, DialogProps.classes, {
      container: classes.container,
      paper: classes.paper
    }),
    children: [/*#__PURE__*/_jsx(DialogContent, {
      className: classes.content,
      children: children
    }), /*#__PURE__*/_jsxs(DialogActions, {
      className: clsx(classes.action, (clearable || showTodayButton) && classes.withAdditionalAction),
      children: [clearable && /*#__PURE__*/_jsx(Button, {
        onClick: onClear,
        children: clearText
      }), showTodayButton && /*#__PURE__*/_jsx(Button, {
        onClick: onSetToday,
        children: todayText
      }), cancelText && /*#__PURE__*/_jsx(Button, {
        onClick: onDismiss,
        children: cancelText
      }), okText && /*#__PURE__*/_jsx(Button, {
        onClick: onAccept,
        children: okText
      })]
    })]
  }));
};

export default withStyles(styles, {
  name: 'MuiPickersModalDialog'
})(PickersModalDialog);